const testimonyAccordion = document.querySelectorAll(
  '.acheter-vendre-accordion'
);

/**
 * SWIPER
 */

const galeries = new Swiper('.acheter-vendre figure .swiper', {
  slidesPerView: 1,
  loop: true,
  navigation: {
    nextEl: '.acheter-vendre figure .swiper-button-next',
    prevEl: '.acheter-vendre figure .swiper-button-prev',
  },
});

const swiperFrise = new Swiper('.acheter-vendre__frise', {
  slidesPerView: 5,
  navigation: {
    nextEl: '.acheter-vendre__frise__nav .swiper-button-next',
    prevEl: '.acheter-vendre__frise__nav .swiper-button-prev',
  },

  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    576: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 4,
    },
    1200: {
      slidesPerView: 5,
    },
  },
});

const carrouselBiens = new Swiper('.carrousel-biens', {
  slidesPerView: 'auto',
  navigation: {
    nextEl: '.carrousel-biens .swiper-button-next',
    prevEl: '.carrousel-biens .swiper-button-prev',
  },
  freeMode: true,
  grabCursor: true,
});

const testimonySwiper = new Swiper('#testimony-swiper', {
  slidesPerView: 1,
  loop: true,
  effect: 'fade',
});

testimonyAccordion.forEach((accordion) => {
  accordion.addEventListener('click', () => {
    const idx = accordion.dataset.index;
    testimonySwiper.slideTo(idx);
  });
});
